var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCgdb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-CGDB"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CGDB",
    clipPath: "url(#clip-CGDB)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(4 84)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 320,
    transform: "translate(89.5 276.5)",
    fill: "none",
    stroke: "#393636",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_158",
    "data-name": "Path 158",
    transform: "translate(90 132)",
    fill: "#0d0d0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 315 120 L 5 120 L 5 5 L 315 5 L 315 120 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 10 L 10 115 L 310 115 L 310 10 L 10 10 M 0 0 L 320 0 L 320 125 L 0 125 L 0 0 Z",
    stroke: "none",
    fill: "#0d0c0c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_159",
    "data-name": "Path 159",
    transform: "translate(63 94)",
    fill: "#0d0c0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 321.6772766113281 33 L 49.32273101806641 33 L 185.5 5.103848457336426 L 321.6772766113281 33 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185.5 10.2076587677002 L 98.64529418945312 28 L 272.354736328125 28 L 185.5 10.2076587677002 M 185.5 0 L 371 38 L 0 38 L 185.5 0 Z",
    stroke: "none",
    fill: "#0d0c0c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(219 313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M108.946,169.753q-7.063,0-7.063-9.068,0-8.926,7.063-8.926h10.808V94.236l-7.812,6.234q-3.1,2.409-5.565,1.275a7.56,7.56,0,0,1-3.745-4.25,12.33,12.33,0,0,1-.749-6.659,9.841,9.841,0,0,1,3.531-6.234L120.29,72.7a24.649,24.649,0,0,1,4.495-2.975,10.565,10.565,0,0,1,4.6-1.133,6.093,6.093,0,0,1,5.03,2.267q1.926,2.267,1.926,6.659v74.241h9.738q6.956,0,6.956,8.926,0,9.068-6.956,9.068H108.946Z",
    transform: "translate(-15.787 -236.753)",
    fill: "#e74046"
  })), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M62.706,15.42H32.745a1.959,1.959,0,0,0-.332.074h-5.12a1.936,1.936,0,0,0-1.773,2.07v93.321a1.936,1.936,0,0,0,1.773,2.07H44.624a1.936,1.936,0,0,0,1.773-2.07V81.236h16.31c15.693,0,28.458-14.76,28.458-32.9S78.4,15.42,62.706,15.42ZM61.345,61.836a8.363,8.363,0,0,1-.839.055H46.7c-.04,0-.071-.037-.111-.055a.377.377,0,0,1-.19-.092.57.57,0,0,1-.166-.4V35.31a.57.57,0,0,1,.166-.4.316.316,0,0,1,.174-.083c.047-.018.071-.055.119-.055H60.5c.317,0,.633.028.942.055,5.737.582,10.264,6.414,10.264,13.5.008,7.126-4.566,12.986-10.359,13.5Z",
    transform: "translate(128.48 130.58)",
    fill: "#e74046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M83.486,34.672H39.659V57.134H78.074V74.1H39.659v40.952h-18V17.512h61.83v17.16Z",
    transform: "translate(204.844 128.488)",
    fill: "#e74046",
    stroke: "#e74046",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M7008.528,842.562l444.005-43.119",
    transform: "translate(-6988 -728)",
    fill: "none",
    stroke: "#0c0b0b",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M6984,644l106.1,510.88H6984Z",
    transform: "translate(-6988 -728)",
    fill: "#0c0b0b",
    stroke: "#040404",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgdb);
export default __webpack_public_path__ + "static/media/CGDB.011badef95d1da1cac6eda44f2477ae6.svg";
export { ForwardRef as ReactComponent };